import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Flame } from "lucide-react";
import { currentUser } from "@/lib/mockData";
import { fmtNumber } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SparkPill() {
  const [balance, setBalance] = useState(null);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/sparks/balance`, { params: { user_id: currentUser.id } });
      setBalance(data);
    } catch { /* offline ok */ }
  };

  useEffect(() => {
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    const id = setInterval(load, 15000);
    return () => { window.removeEventListener("focus", onFocus); clearInterval(id); };
  }, []);

  return (
    <Link
      to="/perfil"
      data-testid="topbar-sparks"
      className="hidden md:inline-flex items-center gap-2 h-10 px-3 rounded-full bg-cream-card border hairline hover:border-coral hover:bg-cream-deep transition group"
      title="Tu progreso Spark"
    >
      <span className="w-6 h-6 rounded-full bg-coral/15 text-coral flex items-center justify-center">
        <Flame className="w-3.5 h-3.5" strokeWidth={2} />
      </span>
      <span className="font-mono text-xs text-ink">
        {fmtNumber(balance?.total_sparks ?? 0)} <span className="text-coral">✦</span>
      </span>
      <span className="hidden lg:inline-flex font-mono text-[9px] uppercase tracking-[0.22em] text-ink-mid group-hover:text-coral transition">
        {balance?.level_name || "Fundador"}
      </span>
    </Link>
  );
}
